import { useEffect, useState } from 'react';

export function formatRemaining(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${r.toString().padStart(2, '0')}`;
}

/** Returns remaining seconds for a phase ending at the given ISO time, ticking 4x/sec. */
export function useCountdown(endsAt: string | null): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!endsAt) return;
    setNow(Date.now());
    const t = setInterval(() => setNow(Date.now()), 250);
    return () => clearInterval(t);
  }, [endsAt]);
  if (!endsAt) return 0;
  const end = new Date(endsAt).getTime();
  return Math.max(0, Math.round((end - now) / 1000));
}

/** Like useCountdown but keeps counting past zero (negative) for manual phases such as voting. */
export function useSignedCountdown(endsAt: string | null): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!endsAt) return;
    setNow(Date.now());
    const t = setInterval(() => setNow(Date.now()), 250);
    return () => clearInterval(t);
  }, [endsAt]);
  if (!endsAt) return 0;
  const end = new Date(endsAt).getTime();
  return Math.round((end - now) / 1000);
}

export function formatSigned(seconds: number): string {
  const neg = seconds < 0;
  const s = Math.abs(Math.floor(seconds));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${neg ? '-' : ''}${m}:${r.toString().padStart(2, '0')}`;
}
